import { render, staticRenderFns } from "./ProjectInvite.vue?vue&type=template&id=df7526d2"
import script from "./ProjectInvite.vue?vue&type=script&lang=js"
export * from "./ProjectInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports